import { Model } from "flexlayout-react";
import { CombinedChart } from "../charts/CombinedChart";
import { StudyChart } from "../charts/StudyChart";
import { FilterList } from "../filterlist/FilterList";
import { TableView } from "../tableview/TableView";
import { TableControl } from "../tableview/TableControl";
import { Controls } from "../controls/Controls";
import { Header } from "../../../components/Header";
import { FilterTitle, NoTitle } from "./VectorSet2Titles";

export const factory = (node) => {
  var component = node.getComponent();
  switch (component) {
    case "VectorSetStudy":
      return <StudyChart />;
    case "CombinedChart":
      return <CombinedChart />;
    case "VectorSet":
      return <FilterList field={"VectorSet"} search={true} />;
    case "VecLevel":
      return <FilterList field={"VecLevel"} search={false} />;
    case "VecEvents":
      return <FilterList field={"VecEvents"} search={true} />;
    case "VecDates":
      return <FilterList field={"VecDates"} search={true} />;
    case "TableView":
      return <TableView />;
    case "TableControl":
      return <TableControl />;
    case "Controls":
      return <Controls />;
    case "Header":
      return (
        <Header
          title="Vector Strength attempts to quantify support and resistance. The
        Vector Model price probabilities come from machine learning applied
        to Vector Strength and several of the V-Score metrics, for thousands
        of tickers-model date combinations. Explore and fitler the Vector
        Strength Histogram below and see our blog to learn more."
          label="vectorset2"
        >
          <div>
            Vector Strength Histogram and Forward Price Percentile Probability
            Estimates.
          </div>
        </Header>
      );
    default:
      return null;
  }
};

export const onRenderTabSet = (tabSetNode, refs) => {
  const typeNode = tabSetNode.getType();
  if (typeNode === "tabset") {
    const children = tabSetNode.getChildren();
    children.forEach((child) => {
      const c = child;
      const comp = c.getComponent();
      const rect = c.getRect();
      if (comp) {
        refs.componentSize.current[comp] = {
          width: rect.width,
          height: rect.height,
        };
      }
    });
  }
};
const getParentTabsets = (model) => {
  const tree = {};
  const walk = (obj) => {
    if (obj.children) {
      const parent = obj.id;
      tree[parent] = [];
      obj.children.forEach((item) => {
        tree[parent].push(item.id);
        walk(item);
      });
    }
  };
  walk(model.layout);
  const parents = {};
  Object.entries(tree).forEach((item) => {
    item[1].forEach((child) => {
      parents[child] = item[0];
    });
  });
  return parents;
};

const modifyModel = (model, layoutState, setLayoutState) => {
  if (layoutState.actionRef.current !== undefined) {
    let tabsetId = "";
    if (layoutState.actionRef.current.isTab) {
      const parent = getParentTabsets(model);
      tabsetId = parent[layoutState.actionRef.current.tabid];
    } else {
      tabsetId = layoutState.actionRef.current.tabid;
    }
    let update = (obj) => {
      if (obj.id === tabsetId) {
        //update
        Object.entries(layoutState.actionRef.current.attributes).forEach(
          (item) => {
            obj[item[0]] = item[1];
          }
        );
      } else if (obj.children) {
        obj.children.forEach((item) => update(item));
      }
    };
    update(model.layout);

    const newState = {
      ...layoutState,
      model: Model.fromJson(model),
    };

    setLayoutState(newState);
    return model;
  } else {
    return model;
  }
};

export const onAction = (action, layoutState) => {
  const nodeID = action.data.fromNode;
  if (nodeID) {
    layoutState.actions.prepareAction(nodeID);
  }
  return action;
};

export const layoutModelChange = (
  model,
  layoutState,
  setLayoutState,
  grefs
) => {
  grefs.layout.current = JSON.stringify(
    modifyModel(model.toJson(), layoutState, setLayoutState)
  );
};

export const onRenderTab = (node, renderState, componentSize) => {
  var component = node.getComponent();
  switch (component) {
    case "CombinedChart":
      renderState.content = (
        <NoTitle componentSize={componentSize} name={"CombinedChart"} />
      );
      break;
    case "VecLevel":
      renderState.content = (
        <FilterTitle
          componentSize={componentSize}
          title={"VecLevel"}
          name={component}
        />
      );
      break;
    case "VectorSet":
      renderState.content = (
        <FilterTitle
          componentSize={componentSize}
          title={"VectorSet"}
          name={component}
        />
      );
      break;
    case "VecEvents":
      renderState.content = (
        <FilterTitle
          componentSize={componentSize}
          title={"VecEvents"}
          name={component}
        />
      );
      break;
    case "VecDates":
      renderState.content = (
        <FilterTitle
          componentSize={componentSize}
          title={"VecDates"}
          name={component}
        />
      );
      break;
    case "Controls":
      renderState.content = (
        <NoTitle componentSize={componentSize} name={"Controls"} />
      );
      break;
    case "Header":
      renderState.content = (
        <NoTitle componentSize={componentSize} name={"Header"} />
      );
      break;
    case "TableView":
      renderState.content = (
        <NoTitle componentSize={componentSize} name={"TableView"} />
      );
      break;
    case "TableControl":
      renderState.content = (
        <NoTitle componentSize={componentSize} name={"TableControl"} />
      );
      break;
    default:
    //do nothing
  }
};
